import Cookie from "js-cookie";
import { isPlainObject, mapValues } from "lodash-es";
import { wxInit, myInit } from "./mini-program";

/**
 * 获取当前浏览器环境（APP/小程序/第三方浏览器）
 */
export const getBrowserEnv = () => {
  const UA = navigator.userAgent || "";
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

  return {
    isXPApp,
    isWX,
    isWXApp,
    isMyApp,
  };
};

export const uuidGenerator = (len?: number, radix?: number) => {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  const uuid: any[] = [];
  let i;
  radix = radix || chars.length;
  len = len || 16;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join("");
};

/**
 * 获取设备ID
 * @param cookieName
 * @returns
 */
export const getDeviceId = (cookieName: string) => {
  if (Cookie.get(cookieName)) {
    return Cookie.get(cookieName);
  } else {
    const deviceId = uuidGenerator();
    Cookie.set(cookieName, deviceId, { expires: 7, path: "/" });
    return deviceId;
  }
};

/**
 * 返回当前页面的环境，依赖于当前域名
 */
export function getClientEnv() {
  let env: "test" | "deploy" | "product" = "test";
  if (window.location.href.indexOf("static.deploy-test.xiaopeng.com") !== -1) {
    env = "deploy";
  } else if (window.location.href.indexOf("static.xiaopeng.com") !== -1) {
    env = "product";
  }
  return env;
}

export const getChannel = () => {
  const UA = navigator.userAgent || "";
  const isDragon = /XdragonWebView/i.test(UA); // 骁龙app
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序
  if (isXPApp) {
    return "xpApp";
  } else if (isMyApp || isWXApp) {
    return isMyApp ? "alipay" : "weapp";
  } else if (isDragon) {
    return "dragon";
  } else {
    if (isIOS()) {
      return "iosBrowser";
    } else {
      return "browser";
    }
  }
};
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
/**
 * 获取query参数对象
 */
export function getQueryObj(customSearch?: string): any {
  const obj: any = {};
  let searchString;
  if (customSearch) {
    searchString = customSearch.substr(1);
  } else {
    searchString = window.location.search.substr(1);
  }
  const params = searchString.split("&");
  params.forEach((str) => {
    const arr = str.split("=");
    if (arr[0] && arr[1]) {
      obj[arr[0]] = `${arr[1]}`;
    }
  });
  return obj;
}

/**
 * 将对象转换为url参数
 * @param url {string}
 * @param params {object}
 * @returns {string}
 */
export function transformToQueryUrl(url: string, params: any): string {
  let query = "";
  if (params && Object.keys(params).length > 0) {
    query = "?";
    let count = 1;
    for (const ele in params) {
      if (count < Object.keys(params).length) {
        query += ele + "=" + params[ele] + "&";
        count++;
      } else {
        query += ele + "=" + params[ele];
      }
    }
  }
  return url + query;
}


/**
 * 通用H5页面跳转方法
 * H5需要在APP\小程序\普通浏览器中都可以打开，特殊考虑小程序页面跳转需要使用小程序的跳转方式，封装一个H5页面跳转方法
 * @param url
 * @param appId 业务方H5的用户中心appid
 * @param params
 */
export async function goToPage(url: string, appId = "", params = {}) {
  try {
    if (!url) return;

    const { isXPApp, isWXApp, isMyApp } = getBrowserEnv();

    if (isWXApp) {
      wxInit().then((wx) =>
        wx.miniProgram.navigateTo({
          url: `/pages/webpage/index?pageUrl=${encodeURIComponent(
            transformToQueryUrl(url, params),
          )}&appId=${appId}`,
        }),
      );
    } else if (isMyApp) {
      myInit().then((my) =>
        my.navigateTo({
          url: `/pages/webpage/index?pageUrl=${encodeURIComponent(
            transformToQueryUrl(url, params),
          )}&appId=${appId}`,
        }),
      );
    } else {
      //  setTimeout(() => {
      //    window.location.href = transformToQueryUrl(url, params);
      //  }, 300);
      // isXPApp & other
      await new Promise((resolve) => {
        setTimeout(() => {
          // window.location.href = transformToQueryUrl(url, params);
          const { origin, pathname, hash } = window.location;
          let hashPath = hash;
          if (hash) {
            hashPath = hash.split("?")?.[0] || hashPath;
          }
          let hashUrl = `${origin}${pathname}${hashPath}`;
          window.location.href = transformToQueryUrl(url, params);
          if (url.indexOf(hashUrl) == 0) {
            // 如果跳转地址 hash 路径一直，需要reload
            window.location?.reload?.();
          }
          resolve(true);
        }, 300);
      });
    }
  } catch (e) {
    console.error(e);
  }
}


/**
 * rem转px
 * @param remValue
 * @returns
 */
export function rem2px(remValue: number | string): number {
  // 安全解析输入值
  const rem =
    typeof remValue === "string"
      ? parseFloat(remValue.replace("rem", ""))
      : remValue;

  // 直接获取html元素的字体大小（更可靠）
  const rootFontSize = parseRootFontSize();
  return rem * rootFontSize;
}

/**
 * @returns 根元素的字体大小
 */
function parseRootFontSize(): number {
  if (typeof document === "undefined") return 16; // SSR兜底

  try {
    // 方案1：直接解析html标签的font-size（最高优先级）
    const htmlStyle = document.documentElement.style.fontSize;
    if (htmlStyle) {
      const parsed = parseFloat(htmlStyle);
      if (!isNaN(parsed)) return parsed;
    }

    // 方案2：获取计算样式（避免触发重排）
    const computed = getComputedStyle(document.documentElement).fontSize;
    return parseFloat(computed) || 16;
  } catch (e) {
    return 16; // 异常兜底
  }
}

/**
 * 转px(只支持rem、vh、vw单位转换)
 * @param value
 * @param baseElement
 * @returns
 */
export function toPx(value: number | string): number | string {
  try {
    // 数值型直接返回
    if (typeof value === "number") return value;

    // 安全解析输入值
    const unitValue = value.trim().toLowerCase();
    const numericValue = parseFloat(unitValue);
    if (isNaN(numericValue)) return 0;

    // 单位类型判断
    if (unitValue.endsWith("px")) {
      return numericValue;
    } else if (unitValue.endsWith("rem")) {
      return numericValue * parseRootFontSize();
    } else if (unitValue.endsWith("vh")) {
      return (numericValue * window.innerHeight) / 100;
    } else if (unitValue.endsWith("vw")) {
      return (numericValue * window.innerWidth) / 100;
    } else {
      throw new Error(`只支持rem、vh、vw单位转换`);
    }
  } catch (error) {
    return value;
  }
}

/**
 * 配置转换器：将对象的指定字段统一转为px单位
 * @param config 原始配置对象
 * @param fields 需要转换的字段列表
 * @returns 转换后的配置对象
 */
export function transformFieldsToPx(
  config: any,
  fields: string[] = ["width", "height", "top", "fontSize"],
): any {
  // 深度优先遍历转换
  function deepTransform(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => deepTransform(item));
    }

    if (isPlainObject(obj)) {
      return mapValues(obj, (value, key) => {
        if (fields.includes(key)) {
          return toPx(value); // 转换目标字段
        }
        return deepTransform(value); // 递归处理子对象
      });
    }

    return obj;
  }

  return deepTransform(config);
}

// 异步加载脚本
export function loadScript(scriptUrl: string, id: string): Promise<any> {
  if (!id) throw new Error("id is needed");
  if (!scriptUrl) throw new Error("scriptUrl is needed, please");

  const pro = new Promise((resolve: Function, reject: Function) => {
    // 避免缓存
    const $oldScript = document.getElementById("#" + id);
    if ($oldScript) {
      resolve();
      return;
    }
    const $script = document.createElement("script");
    $script.id = id;
    $script.type = "text/javascript";
    $script.onload = () => {
      resolve();
    };
    $script.onerror = (err) => {
      reject(err);
    };
    $script.src = scriptUrl;
    document.head.appendChild($script);
  });
  return pro;
}
